import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import { initAnalytics } from './lib/analytics';
import './styles/haplika.css';
import './styles/app.css';

const Landing = lazy(() => import('./landing/Landing'));
const EmpresasApp = lazy(() => import('./empresas/EmpresasApp'));
const CandidatosApp = lazy(() => import('./candidatos/CandidatosApp'));
const Backoffice = lazy(() => import('./backoffice/Backoffice'));

initAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Landing aud="empresas" />} />
          <Route path="/empresas" element={<Landing aud="empresas" />} />
          <Route path="/candidatos" element={<Landing aud="candidatos" />} />
          <Route path="/empresas/*" element={<EmpresasApp />} />
          <Route path="/app/*" element={<CandidatosApp />} />
          <Route path="/admin/*" element={<Backoffice />} />
          <Route path="*" element={<Landing aud="empresas" />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </StrictMode>,
);
